import testingCommisionaAtionTypes from '../../actions/TestingCommission/TCActionTypes';
//*means import all action
//Generic Action Creator 
export const DispatchAction = (type, payload) => ({
    type,
    payload,
  });
  
  //Specific action creator
  export const setBasicDetailsFields = (fields) => ({
    type: testingCommisionaAtionTypes.SET_BASIC_DETAILS_FIELDS,
    payload: fields,
  });
  
  export const setBasicDetailsMandatoryFields = (mandatoryFields) => ({
    type: testingCommisionaAtionTypes.SET_BASIC_DETAILS_MANDATORY_FIELDS,
    payload: mandatoryFields,
  });
  
  export const setErrorMessage = (field, message) => ({
    type: testingCommisionaAtionTypes.SET_ERROR_MESSAGE,
    field,
    message,
  });

  export const setOthersDetailsFields = (fields) => ({
    type: testingCommisionaAtionTypes.SET_OTHERS_DETAILS_FIELDS,
    payload: fields,
  });